import {
  BlurEffect,
  DiffIndicator,
  ImageWrapper,
  ItemContent,
  ItemName,
  TierImage,
  TierWrapper,
  ValueText,
  ValueWrapper,
} from "./styles";

export interface TierItemProps {
  imageSrc: string;
  imageAlt: string;
  name: string;
  value: string;
  unit: string;
  diff: number;
  flex?: number;
}
// 화살표 방향 결정 함수
const getArrowDirection = (diff: number): string => {
  if (diff > 0) return "up";
  if (diff === 0) return "no";
  return "down";
};

const TierItem = ({
  imageSrc,
  imageAlt,
  name,
  value,
  unit,
  diff,
  flex,
}: TierItemProps) => {
  const arrowDirection = getArrowDirection(diff);
  const showDiff = diff !== 0;
  const diffValue = Math.abs(diff);

  return (
    <TierWrapper flex={flex}>
      <ImageWrapper>
        <TierImage src={imageSrc} alt={imageAlt} />
        <BlurEffect />
      </ImageWrapper>
      <ItemContent>
        <ItemName>{name}</ItemName>
        <ValueWrapper>
          <ValueText>
            {value}
            <span>{unit}</span>
          </ValueText>
          {showDiff && (
            <DiffIndicator>
              <img
                src={`image-web/home/rank-arrow-${arrowDirection}.svg`}
                alt={arrowDirection}
              />
              <div>{diffValue}</div>
            </DiffIndicator>
          )}
        </ValueWrapper>
      </ItemContent>
    </TierWrapper>
  );
};
export default TierItem;
